<!-- TARIFARIO DE LIQUIDACIÓN (Mario, 07-oct-2026): la tabla de plazos que alimenta el selector de
     «Plazo y comisión» en las condiciones de cada comercio. Estilo de la casa: kb-card, kb-table,
     kb-badge; el principal en negro, como en Comercios. -->
<div class="kb-page space-y-6">

  <nav class="kb-migas" aria-label="Migas">
    <a class="kb-miga" routerLink="/console/parametros-sistema">Parámetros del sistema</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <a class="kb-miga" routerLink="/console/parametros-sistema/liquidacion">Liquidación a comercios</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <span class="kb-miga-actual">Tarifario de liquidación</span>
  </nav>

  <div class="kb-page-header">
    <div class="max-w-[720px]">
      <h1 class="kb-page-title">Tarifario de liquidación</h1>
      <p class="kb-page-meta">La tabla de plazos de la que salen el nombre del plazo y la comisión al cargar las
        condiciones de un comercio. Una versión nueva rige desde su fecha y las condiciones guardan qué tabla usaron.</p>
    </div>
    <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90 shrink-0"
            *ngIf="puedeEditar && !creando && !cargando && !error" (click)="abrirNueva()">
      <i class="fas fa-plus" aria-hidden="true"></i>Nueva versión de la tabla
    </button>
    <span class="kb-badge kb-badge-neutro shrink-0" *ngIf="!puedeEditar" title="La versionan la gerente de finanzas y el director"><i class="fas fa-eye" aria-hidden="true"></i>Solo lectura</span>
  </div>

  <!-- Una tabla por tipo de contrato (Mario, 11-oct): cada pestaña con sus versiones. -->
  <div class="kb-tabs-list" role="tablist" aria-label="Tipo de contrato">
    <button type="button" role="tab" class="kb-pestana" [class.kb-pestana-activa]="tipo === 'COMPRA_DEUDA'" [attr.aria-selected]="tipo === 'COMPRA_DEUDA'" (click)="verTipo('COMPRA_DEUDA')">Compra de deuda</button>
    <button type="button" role="tab" class="kb-pestana" [class.kb-pestana-activa]="tipo === 'COBRANZA'" [attr.aria-selected]="tipo === 'COBRANZA'" (click)="verTipo('COBRANZA')">Servicio de cobranza</button>
  </div>
  <p class="kb-hint !mt-0" *ngIf="tipo === 'COBRANZA'">En cobranza la comisión es un % de lo cobrado de cada abono, y el plazo dice cuántos días después del cobro se le paga al comercio.</p>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
  </div>
  <div class="kb-cinta kb-cinta-info" *ngIf="aviso" role="status">
    <i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i><span>{{ aviso }}</span>
  </div>
  <p class="kb-hint" *ngIf="cargando">Cargando el tarifario…</p>

  <!-- ══ Versión nueva ══════════════════════════════════════════════════════ -->
  <section class="kb-card" *ngIf="creando" aria-labelledby="tfTituloNueva">
    <div class="kb-card-header">
      <div>
        <h2 id="tfTituloNueva" class="kb-card-title">Nueva versión de la tabla</h2>
        <p class="kb-card-desc">Arranca con la tabla vigente: cambia lo que haga falta. Tope de comisión: {{ TOPE }} %.</p>
      </div>
    </div>
    <div class="kb-card-body space-y-5">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-[200px_minmax(0,1fr)]">
        <div>
          <label class="kb-label" for="tfDesde">Rige desde <span class="text-destructive">*</span></label>
          <input id="tfDesde" type="date" class="kb-input" [(ngModel)]="nueva.desde">
        </div>
        <div>
          <label class="kb-label" for="tfNota">Nota</label>
          <input id="tfNota" type="text" class="kb-input" placeholder="Por ejemplo: tabla definitiva de Ángela"
                 [(ngModel)]="nueva.nota">
        </div>
      </div>
      <label class="inline-flex items-center gap-2 text-sm text-foreground cursor-pointer" for="tfProvisional">
        <input id="tfProvisional" type="checkbox" class="kb-radio rounded" [(ngModel)]="nueva.provisional">
        Marcarla como provisional
      </label>

      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th w-[140px]">Días</th>
              <th class="kb-th">Nombre del plazo</th>
              <th class="kb-th kb-th-num w-[160px]">Comisión</th>
              <th class="kb-th kb-th-acciones"><span class="sr-only">Quitar</span></th>
            </tr>
          </thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let r of nueva.rows; let i = index">
              <td class="kb-td">
                <input [id]="'tfDias' + i" type="number" min="1" step="1" class="kb-input text-right tabular-nums"
                       [(ngModel)]="r.days" [attr.aria-label]="'Días de la fila ' + (i + 1)">
              </td>
              <td class="kb-td">
                <input [id]="'tfNombre' + i" type="text" class="kb-input" placeholder="Quincenal"
                       [(ngModel)]="r.label" [attr.aria-label]="'Nombre de la fila ' + (i + 1)">
              </td>
              <td class="kb-td">
                <div class="relative">
                  <input [id]="'tfComision' + i" type="number" min="0" [max]="TOPE" step="0.01"
                         class="kb-input pr-8 text-right tabular-nums" [(ngModel)]="r.commission_value"
                         [attr.aria-label]="'Comisión de la fila ' + (i + 1)">
                  <span class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">%</span>
                </div>
              </td>
              <td class="kb-td-acciones">
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="quitarFila(i)"
                        [attr.aria-label]="'Quitar la fila ' + (i + 1)">
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="agregarFila()">
        <i class="fas fa-plus" aria-hidden="true"></i>Agregar un plazo
      </button>

      <ul class="m-0 space-y-1 pl-0 text-sm kb-texto-peligro list-none" *ngIf="errores.length" aria-live="polite">
        <li *ngFor="let e of errores" class="flex items-start gap-2">
          <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>{{ e }}
        </li>
      </ul>
      <div class="kb-aviso kb-aviso-peligro" *ngIf="errorGuardar" role="alert">
        <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ errorGuardar }}</p></div>
      </div>
    </div>
    <div class="kb-card-footer">
      <button type="button" class="kb-btn kb-btn-ghost" (click)="creando = false">Cancelar</button>
      <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90"
              [disabled]="errores.length || guardando" (click)="guardar()">
        <i class="fas fa-check" aria-hidden="true"></i>{{ guardando ? 'Guardando…' : 'Crear la versión' }}
      </button>
    </div>
  </section>

  <!-- ══ Vigente ════════════════════════════════════════════════════════════ -->
  <section class="kb-card" *ngIf="vigente && !creando" aria-labelledby="tfTituloVigente">
    <div class="kb-card-header">
      <div>
        <h2 id="tfTituloVigente" class="kb-card-title">Tabla vigente</h2>
        <p class="kb-card-desc">{{ vigente.version.code }} ·
          {{ vigente.origen === 'PROVISIONAL_DEL_CODIGO' ? 'todavía no hay una tabla cargada en la base' :
             'rige desde el ' + (vigente.version.date_init | date:'dd/MM/yyyy') }}</p>
      </div>
      <div class="flex flex-wrap gap-2">
        <span class="kb-badge kb-badge-exito"><i class="fas fa-check-circle" aria-hidden="true"></i>Vigente</span>
        <span class="kb-badge kb-badge-alerta" *ngIf="vigente.provisional"><i class="fas fa-hourglass-half" aria-hidden="true"></i>Provisional</span>
      </div>
    </div>
    <div class="kb-card-body space-y-4">
      <div class="kb-cinta" *ngIf="vigente.provisional">
        <i class="fas fa-info-circle kb-cinta-icono" aria-hidden="true"></i>
        <span>{{ vigente.nota || 'Tabla provisional.' }}
          <ng-container *ngIf="vigente.origen === 'PROVISIONAL_DEL_CODIGO'"> La primera versión que crees aquí la reemplaza desde su fecha.</ng-container></span>
      </div>
      <div class="kb-table-envoltorio max-w-[680px]">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr><th class="kb-th">Plazo</th><th class="kb-th">Nombre</th><th class="kb-th kb-th-num">Comisión</th></tr>
          </thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let r of vigente.rows">
              <td class="kb-td kb-td-titulo">{{ textoDias(r.days) }}</td>
              <td class="kb-td">{{ r.label }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ r.commission_value }} %</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="kb-hint !mt-4" *ngIf="tipo !== 'COBRANZA'">Sobre qué se calcula la comisión (saldo a financiar, monto vendido o lo cobrado) se elige
        en las condiciones de cada comercio.</p>
    </div>
  </section>

  <!-- ══ Historial ══════════════════════════════════════════════════════════ -->
  <section class="kb-card" *ngIf="versiones.length && !creando" aria-labelledby="tfTituloHistorial">
    <div class="kb-card-header">
      <div>
        <h2 id="tfTituloHistorial" class="kb-card-title">Historial</h2>
        <p class="kb-card-desc">Cada versión explica las condiciones que se crearon con ella.</p>
      </div>
      <span class="kb-badge kb-badge-neutro">{{ versiones.length }} {{ versiones.length === 1 ? 'versión' : 'versiones' }}</span>
    </div>
    <div class="w-full overflow-x-auto">
      <table class="kb-table">
        <thead class="kb-thead">
          <tr><th class="kb-th">Versión</th><th class="kb-th">Vigencia</th><th class="kb-th kb-th-num">Plazos</th><th class="kb-th">Nota</th></tr>
        </thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let v of versiones" [class.kb-tr-elegida]="v === vigente">
            <td class="kb-td">
              <div class="kb-td-titulo font-mono">{{ v.version.code }}</div>
              <div class="kb-td-sub">
                <span *ngIf="v === vigente">vigente</span><span *ngIf="v === vigente && v.provisional"> · </span><span *ngIf="v.provisional">provisional</span>
              </div>
            </td>
            <td class="kb-td whitespace-nowrap">
              {{ v.version.date_init ? (v.version.date_init | date:'dd/MM/yyyy') : 'Desde el código' }}
              <span class="text-muted-foreground"> → {{ v.version.date_end ? (v.version.date_end | date:'dd/MM/yyyy') : 'sin fin' }}</span>
            </td>
            <td class="kb-td kb-td-num">{{ v.rows?.length }}</td>
            <td class="kb-td text-muted-foreground">{{ v.nota || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
